/**
 * Load GA4 event listeners
 * */

// view_item_list event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#view_item_list
pmw.bus.on("pmw:pixel:view-item-list", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_analytics")) return;
		if (!pmwDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!pmw.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		pmw.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		}).catch(pmw.gtagNotLoaded(`Google Analytics: ${ga4Data.event_name}`));
	} catch (e) {
		console.error(e);
	}
});

// select_item event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#select_item
pmw.bus.on("pmw:pixel:select-item", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_analytics")) return;
		if (!pmwDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!pmw.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		pmw.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		}).catch(pmw.gtagNotLoaded(`Google Analytics: ${ga4Data.event_name}`));
	} catch (e) {
		console.error(e);
	}
});

// add_to_cart event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#add_to_cart
pmw.bus.on("pmw:pixel:add-to-cart", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_analytics")) return;
		if (!pmwDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!pmw.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		pmw.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		}).catch(pmw.gtagNotLoaded(`Google Analytics: ${ga4Data.event_name}`));
	} catch (e) {
		console.error(e);
	}
});

// view_item event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#view_item
pmw.bus.on("pmw:pixel:view-item", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_analytics")) return;
		if (!pmwDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!pmw.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		pmw.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		}).catch(pmw.gtagNotLoaded(`Google Analytics: ${ga4Data.event_name}`));
	} catch (e) {
		console.error(e);
	}
});

// add_to_wishlist event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#add_to_wishlist
pmw.bus.on("pmw:pixel:add-to-wishlist", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_analytics")) return;
		if (!pmwDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!pmw.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		pmw.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		}).catch(pmw.gtagNotLoaded(`Google Analytics: ${ga4Data.event_name}`));
	} catch (e) {
		console.error(e);
	}
});

// remove_from_cart event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#remove_from_cart
pmw.bus.on("pmw:pixel:remove-from-cart", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_analytics")) return;
		if (!pmwDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!pmw.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		pmw.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		}).catch(pmw.gtagNotLoaded(`Google Analytics: ${ga4Data.event_name}`));
	} catch (e) {
		console.error(e);
	}
});

// begin_checkout event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#begin_checkout
pmw.bus.on("pmw:pixel:begin-checkout", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_analytics")) return;
		if (!pmwDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!pmw.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		pmw.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		}).catch(pmw.gtagNotLoaded(`Google Analytics: ${ga4Data.event_name}`));
	} catch (e) {
		console.error(e);
	}
});

// add_shipping_info event
pmw.bus.on("pmw:pixel:add-shipping-info", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_analytics")) return;
		if (!pmwDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!pmw.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		pmw.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		}).catch(pmw.gtagNotLoaded(`Google Analytics: ${ga4Data.event_name}`));
	} catch (e) {
		console.error(e);
	}
});

// add_payment_info event
pmw.bus.on("pmw:pixel:add-payment-info", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_analytics")) return;
		if (!pmwDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!pmw.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		pmw.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		}).catch(pmw.gtagNotLoaded(`Google Analytics: ${ga4Data.event_name}`));
	} catch (e) {
		console.error(e);
	}
});

// view_cart event
// https://developers.google.com/analytics/devguides/collection/ga4/ecommerce?client_type=gtag#view_cart
pmw.bus.on("pmw:pixel:view-cart", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_analytics")) return;
		if (!pmwDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!pmw.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		pmw.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		}).catch(pmw.gtagNotLoaded(`Google Analytics: ${ga4Data.event_name}`));
	} catch (e) {
		console.error(e);
	}
});

// view search event
pmw.bus.on("pmw:pixel:search", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_analytics")) return;
		if (!pmwDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;
		if (!pmw.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		pmw.gtagLoaded().then(() => {
			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		}).catch(pmw.gtagNotLoaded(`Google Analytics: ${ga4Data.event_name}`));

	} catch (e) {
		console.error(e);
	}
});

// view order received page event
pmw.bus.on("pmw:pixel:purchase", (payload) => {

	try {
		if (!pmw.shouldFireBrowserPixel(payload, "google_analytics")) return;
		if (!pmwDataLayer?.pixels?.google?.analytics?.ga4?.measurement_id) return;

		console.log("Google GA4 purchase event listener triggered");

		// ga4_server_and_browser_tracking experiment
		// https://app.asana.com/0/1110999795232049/1204453591507565
		// ga4e: if (pmwDataLayer?.pixels?.google?.analytics?.ga4?.mp_active) {
		// 	if (pmwDataLayer?.experiments?.ga4_server_and_browser_tracking) {
		// 		break ga4e
		// 	}
		// 	return
		// }

		// Deactivated for the ga4_server_and_browser_tracking experiment
		if (pmwDataLayer?.pixels?.google?.analytics?.ga4?.mp_active) return;
		if (!pmw.googleConfigConditionsMet({type: "statistics"})) return;

		const ga4Data = payload.pixels?.google_analytics;
		if (!ga4Data) return;

		pmw.gtagLoaded().then(() => {
			// Attach the enhanced conversion user data before the purchase is queued.
			// Needed for conversions recovered by Automatic Conversion Recovery, where
			// the order only arrives after the tag was set up.
			pmw.setGoogleEnhancedConversionData();

			gtag("event", ga4Data.event_name, ga4Data.event_data);
			pmw.console.log(`Google Analytics: ${ga4Data.event_name} event sent`, ga4Data.event_data);
		}).catch(pmw.gtagNotLoaded(`Google Analytics: ${ga4Data.event_name}`));

		// pmw.gtagLoaded().then(function () {
		// 	gtag("get", pmwDataLayer.pixels.google.analytics.ga4.measurement_id, "client_id", (client_id) => {
		// 		console.log("transaction_id: " + pmwDataLayer.order.number + " client_id: " + client_id)
		// 	})
		// })

	} catch (e) {
		console.error(e);
	}
});
